module.exports = __webpack_public_path__ + "img/PGR_A05_front_diagonal_horizontal_en.ac680748.png";